import { create } from 'zustand';

// Types
export interface DesmosStoreConfig {
  storageKey: string;
}

interface DesmosState {
  showLoading: boolean;
}

interface DesmosActions {
  setShowLoading: (loading: boolean) => void;
}

export const desmosStoreConfig: DesmosStoreConfig = {
  storageKey: 'desmosState',
};

export const useDesmosStore = create<DesmosState & DesmosActions & { config: DesmosStoreConfig }>(
  (set) => ({
    showLoading: false,
    config: desmosStoreConfig,
    setShowLoading: (loading: boolean) => set({ showLoading: loading }),
  })
);
